import './DateCell.css';
export default {
    "compactDateCell": "DateCell_compactDateCell__556cz",
    "timeSlot": "DateCell_timeSlot__556cz",
    "selectedCell": "DateCell_selectedCell__556cz",
    "disabledCell": "DateCell_disabledCell__556cz",
    "todayCell": "DateCell_todayCell__556cz",
    "compactSignalIcons": "DateCell_compactSignalIcons__556cz"
};
